import React, { useEffect, useState } from 'react';
import { ControlledTextField, ControlledTextFieldProps } from "./ControlledTextField";
import { EntityWithIdAndDescription } from "../../types/baseEntities";

interface AsyncSelectProps extends ControlledTextFieldProps {
    loadOptions: () => Promise<EntityWithIdAndDescription[]> | undefined,
    filled?: boolean
}

export const AsyncSelect = (props: AsyncSelectProps) => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState<EntityWithIdAndDescription[]>([])

    const { loadOptions } = props;

    useEffect(() => {
        const request = loadOptions();

        if (request) {
            setLoading(true);

            request.then(options => {
                setOptions(options);
                setLoading(false);
            }).catch(error => {
                console.log(error)
                setLoading(false)
            })
        }
    }, [loadOptions]);

    return (
        <ControlledTextField
            {...props}
            select
            options={loading ? undefined : options}
        />
    )
};